import { store } from "../app/store.js";
import {api} from "../app/api.js";
import {display_errors} from "../helpers/forms.js";

export default {
    template: `
        <div class="flexy-column">
            <div class="container">
                <h1>Unsubscribe</h1>
                <p class="center">No longer want to receive emails from King Earthquake?</p>
                <p class="center">Unsubscribe to stop receiving our newsletters and promotional emails.</p>
                
                <form id="UnsubscribeForm" class="form">
                    <div class="input">
                        <label for="UnsubscribeEmailAddress">Email Address</label>
                        <input type="text" id="UnsubscribeEmailAddress" name="email" autocomplete="off"/>
                    </div>
        
                    <button id="UnsubscribeSubmit" type="submit">Unsubscribe</button>
                    <div id="UnsubscribeErrors" class="errors hidden"></div>
                </form>
                
                <div id="UnsubscribeSuccess" class="center hidden">
                    <p class="center">We've removed your email address from our mailing list.</p>
                    <p class="center">Please allow a day or two for our systems to process your request.</p>
                </div>
            </div>
        </div>
    `,

    $form: null,
    $errors: null,
    $submit: null,
    $success: null,

    submit (event) {
        event.preventDefault();

        this.$submit.disabled = true;
        this.$submit.textContent = 'Processing...';
        this.$errors.classList.add('hidden');

        api.post({
            url: '/mailing_lists/unsubscribe_all',
            data: {
                email: this.$form.email.value,
            },
            success: () => {
                this.$form.classList.add('hidden');
                this.$success.classList.remove('hidden');
            },
            error: (response) => {
                display_errors(this.$errors, response, this.$form);

                this.$submit.disabled = false;
                this.$submit.textContent = 'Unsubscribe';
            },
        });
    },
    _boundSubmit: null,

    onMount() {
        document.body.classList.add("frame");

        this.$form = document.getElementById('UnsubscribeForm');
        this.$errors = document.getElementById('UnsubscribeErrors');
        this.$submit = document.getElementById('UnsubscribeSubmit');
        this.$success = document.getElementById('UnsubscribeSuccess');

        this._boundSubmit = this.submit.bind(this);
        this.$form.addEventListener('submit', this._boundSubmit);
    },

    onUnmount() {
        document.body.classList.remove("frame");
        if (this._boundSubmit) this.$form.removeEventListener('submit', this._boundSubmit);
    },
}
